import { defineStore } from 'pinia';
import { store } from '/@/store';
interface IProjectInfo {
  isNew: Number | null;
  project: any | null;
  pInfo: any | null;
}

export const useProjectStore = defineStore({
  id: 'project',
  state: (): IProjectInfo => ({
    isNew: null,
    project: null,
    pInfo: null,
  }),
  actions: {
    setIsNew(num: number) {
      this.isNew = num;
    },
    setProject(project: any) {
      this.project = project;
    },
    setPinfo(info: any) {
      this.pInfo = info;
    },
  },
});

export function useProjectStoreWithOut() {
  return useProjectStore(store);
}
